import ErpBoxList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/boxes") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpBoxList();
    }
}